import React from "react";
import { CircularProgress } from "@components";
import styles from "./PageLoader.module.scss";
export function PageLoader() {
    return (React.createElement("div", { className: styles.wrap },
        React.createElement(CircularProgress, null)));
}
